import { css } from "@emotion/core"

export const inputContainer = css`
  margin-bottom: 1.8rem;
`

export const textInput = css`
  width: stretch;
`
